import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=2dfd23a6&scoped=true&"
var script = {}
import style0 from "./Table.vue?vue&type=style&index=0&id=2dfd23a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd23a6",
  null
  
)

export default component.exports